import React from "react"
import PopularCategories from "./PopularCategories"
import FeaturedCategories from "./FeaturedCategories"

/**
 * FeaturedContent component for the Help Center home page
 * Displays popular categories and featured content
 */
const FeaturedContent = () => {
  return (
    <div className="relative w-full max-w-w2_xl space-y-12">
      {/* Popular categories section - self-contained component */}
      <PopularCategories />

      {/* Featured categories with articles */}
      <FeaturedCategories />
    </div>
  )
}

export default FeaturedContent
